export default "/static/dashboard/build/app/img/v2/d18b031fb287bd3c86a7a2bd04d8ae27.png";